<script>
  import TabulatorBare from '../../UC-tabulator-bare.svelte'
  import AcademicLegend from './UC-AcademicLegend.svelte'
  import { dagInterpolateNumberWithCommas, dagFixedDecimal, dagAcademicStatusIconFormatter } from '../../../shared/utils'

  export let tableTitle = "Ally Course Data"
  export let tableData = []

  /**
    This component will now be very opinionated, as it wraps the 'bare' table to add specific functionality.
      This wll be the only place columns for this table are defined, and cannot be modified from the outside.
      As you may have already noticed in the code above, we're able to leave out the dummy data,
      and data will be set at runtime.
  */
  const tableColumns = [
    { title:"<span class='title'>Semester</span>", field:"SemesterLabel", minWidth: 100 },
    { title:"<span class='title'>Course Count</span>", field:"CourseCount", minWidth: 120, formatter: dagInterpolateNumberWithCommas },
    { title:"<span class='title'>PDF Count</span>", field:"PdfCount", minWidth: 120, formatter: dagInterpolateNumberWithCommas },
    { title:"<span class='title'>Image Count</span>", field:"ImageCount", minWidth: 100, formatter: dagInterpolateNumberWithCommas },
    { title:"<span class='title'>Score</span>", field:"OverallScore", minWidth: 100, formatter: dagFixedDecimal },
    { title:"<span class='title'>Overall</span>", field:"OverallStatusIconId", minWidth: 120, formatter: dagAcademicStatusIconFormatter }
 	]
</script>

<div class="uc-tabulator academic-table">
  <header>
    <div class="table-title"><h3>{ tableTitle }</h3></div>
  </header>
  <TabulatorBare data={ tableData } columns={ tableColumns } />
  <AcademicLegend />
</div>

<style>
  .academic-table {
    background-color: #FFF;
    padding: 2rem 2rem 0 2rem;
    margin: 0 0 3rem 0;
    border-radius: 1.5rem;
  }

  header {
    display: flex;
    justify-content: space-between;
    flex-wrap:wrap;
  }

  .table-title h3 {
    color: var(--uc-red);
    font-size: 3rem;
    font-weight: 600;
  }
    @media(max-width:640px){
      .table-title h3 {
      flex-grow:1;
    }
  }
</style>
